const SESSION_STORAGE_KEY = "logged_in";
const SESSION_USER = "1";
const SESSION_GUEST = "0";

const authenticate = (logged: boolean) => {
  try {
    if (logged) {
      document.documentElement.classList.remove("session-guest");
      document.documentElement.classList.add("session-user");
    } else {
      document.documentElement.classList.remove("session-user");
      document.documentElement.classList.add("session-guest");
    }
  } catch (e) {
    return;
  }
};

const saveSession = (logged: boolean) => {
  try {
    window.localStorage.setItem(
      SESSION_STORAGE_KEY,
      logged ? SESSION_USER : SESSION_GUEST
    );
  } catch {
    return;
  }
};

const initSession = () => {
  const timeOut = setTimeout(() => {
    authenticate(false);
    saveSession(false);
  }, 3000);
  const iframe = document.createElement("iframe");
  iframe.src = `${CONFIG.ssoHost}/session`;
  iframe.style.display = "none";
  document.body.appendChild(iframe);

  window.addEventListener("message", event => {
    if (event.origin === CONFIG.ssoHost) {
      clearTimeout(timeOut);
      authenticate(event.data.loggedIn);
      saveSession(event.data.loggedIn);
    }
  });
};

Defer(initSession, 3000, true);
